import { setSessionState } from '@shoflo/studio-redux/actions';

function sessionStateChanged({ dispatch }, { sessionState }) {
  dispatch(setSessionState(sessionState));
}

export default sessionStateChanged;
